import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/js/importEle.js';
import 'element-ui/lib/theme-chalk/index.css';
import oneLineFooter from '@/components/oneLineFooter.vue'
import onlyLogoNav from '@/components/onlyLogoNav.vue'
import footer from '@/components/footer.vue'
import iconTextNav from '@/components/iconTextNav.vue'
import myNavBar from '@/components/navBar.vue'
import buyTicStatus from '@/components/buyTicStatus.vue'
import SlideVerify from 'vue-monoplasty-slide-verify';
import global from '@/global.js'
import axios from 'axios'
import qs from 'qs'
import '@/assets/css/swiper.min.css' //css样式
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import '@/assets/js/gt.js'



// 添加请求拦截器
axios.interceptors.request.use(function (config) {
    // 在发送请求之前做些什么
	NProgress.start();
    return config;
  }, function (error) {
    // 对请求错误做些什么
	NProgress.done();
    return Promise.reject(error);
  });

// 添加响应拦截器
axios.interceptors.response.use(function (res) {
	NProgress.done();
	if(res.data.code && res.data.code != 0){
		clearTimeout(window.axiosErrTime);
		window.axiosErrTime = setTimeout(() => {
			Vue.prototype.$message.error(res.data.message);
			if (res.data.code == 50003 || res.data.code == 40004 || res.data.code == 48001) {
				//清除全局登录信息、缓存
				store.commit('logout');
				router.push('/logIn')
			}
		}, 300)
	}
    // 对响应数据做点什么
    return res;
  }, function (res) {
	NProgress.done();
	Vue.prototype.$message.error('网络繁忙，请刷新页面重试')
    // 对响应错误做点什么
    return Promise.reject(res);
  });



Vue.prototype.global = global;
Vue.prototype.axios = axios;
Vue.prototype.qs = qs;

Vue.use(SlideVerify)


Vue.component('one-lineFooter',oneLineFooter)
Vue.component('my-footer',footer)
Vue.component('my-iconTextNav',iconTextNav)
Vue.component('my-navBar',myNavBar)
Vue.component('my-buyTicStatus',buyTicStatus)
Vue.component('onlyLogoNav',onlyLogoNav)


Vue.config.productionTip = false


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
